module.exports = __webpack_public_path__ + "img/palmar-kids.f7dbd57f.jpg";